export default __webpack_public_path__ + "6fabe933c8612a3d74b69570fe60328e.jpg";